import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["SpeedInsights"] */ "/vercel/path0/node_modules/.pnpm/@vercel+speed-insights@1.2.0_next@16.1.1_@opentelemetry+api@1.9.0_@playwright+test@1.57.0_rea_5yscesaae7jufest7xnycuuwkq/node_modules/@vercel/speed-insights/dist/next/index.mjs");
